import { ChevronDown, Copy } from "lucide-react";
import { Button } from "../ui/button";
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent,
  DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator,
} from "../ui/dropdown-menu";
import { DYNAMIC_VARIABLES } from "../workflows/TaskEditor";

const EMAIL_VARIABLE_GROUPS = [
  {
    label: "People",
    items: DYNAMIC_VARIABLES.filter((v) =>
      ["Buyer 1", "Seller 1", "Buyer Agent", "Seller Agent", "Lender", "Title Company", "Loan Processor", "Coordinator", "Buyer 2", "Seller 2", "Seller Agent Assistant", "Buyer Agent Assistant"].some(
        (p) => v.label === p || v.label === `${p} First Name` || v.label === `${p} Phone`
      )
    ),
  },
  {
    label: "Transaction",
    items: DYNAMIC_VARIABLES.filter((v) =>
      ["Property Address", "Closing Date", "Contract Date", "Purchase Price", "Earnest Money", "Earnest Money Deadline", "Inspection Deadline", "Insurance Deadline", "Possession Date", "Zillow Link"].includes(v.label)
    ),
  },
];

export const InsertVariableBtn = ({ onInsert }) => (
  <DropdownMenu modal={false}>
    <DropdownMenuTrigger asChild>
      <Button type="button" variant="outline" size="sm" className="text-xs h-6 gap-1 px-2" data-testid="insert-variable-btn">
        <Copy className="w-3 h-3" /> Insert Variable <ChevronDown className="w-3 h-3" />
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent className="w-[500px]" align="end" data-testid="insert-variable-dropdown">
      {EMAIL_VARIABLE_GROUPS.map((group, gi) => (
        <div key={group.label}>
          {gi > 0 && <DropdownMenuSeparator />}
          <DropdownMenuLabel className="text-[10px] uppercase tracking-wider text-[var(--t-text-muted)]">
            {group.label}
          </DropdownMenuLabel>
          {group.items.map((v) => (
            <DropdownMenuItem key={v.value} className="px-4 py-2.5 cursor-pointer" onSelect={() => onInsert(v.value)} data-testid={`var-${v.label.toLowerCase().replace(/\s+/g, '-')}`}>
              <span className="font-mono text-sm text-[var(--t-primary)]">{v.value}</span>
            </DropdownMenuItem>
          ))}
        </div>
      ))}
    </DropdownMenuContent>
  </DropdownMenu>
);
